import {InternalToolsModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const batchAnalysisTabs = defineTabDef({
  periods: {
    tabName: 'periods',
    tabTitle: 'Periods',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_batch_analysis],
  },
  control_groups: {
    tabName: 'control_groups',
    tabTitle: 'Control Groups',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_batch_analysis],
  },
} as const);
